import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { nanoid } from "@reduxjs/toolkit";
import moment from "moment";
import { getSupplierFullName } from "./HelperFunction";
// private
var pipelineStepsFromPesID = [
    mappingLoadByPesID,
    mappingPesItem,
    mappingPesMember
];
export var docLimit = 10;
export var addProductRow = function(num) {
    return Array.from({
        length: num
    }, function() {
        return getDocTableRowPesInit();
    });
};
function mappingPesItem(param) {
    var setProductRow = param.setProductRow, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factPesItem && dataWithReplacements.factPesItem.length > 0) {
        var productItems = dataWithReplacements.factPesItem.map(function(row) {
            var dataType = null;
            var keySelected = null;
            var docID = null;
            if (row.dimNewGr) {
                keySelected = "grReviewListState";
                docID = row.dimNewGr.id;
                dataType = _object_spread_props(_object_spread({}, row.dimNewGr), {
                    total_receive_quantity: row.sum_item_quantity,
                    remark: row.remark,
                    __keySelected: keySelected
                });
            } else if (row.factExpense) {
                keySelected = "expListState";
                docID = row.factExpense.id;
                dataType = _object_spread_props(_object_spread({}, row.factExpense), {
                    totalQuantity: row.sum_item_quantity,
                    remark: row.remark,
                    __keySelected: keySelected
                });
            }
            return mapRowToProductRow(dataType);
        });
        dataWithReplacements.products = productItems;
        var numLeft = docLimit - productItems.length;
        var addEmptyProductList = addProductRow(numLeft);
        setProductRow(_to_consumable_array(productItems).concat(_to_consumable_array(addEmptyProductList)));
    }
}
function mappingPesMember(param) {
    var setPdata = param.setPdata, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factMember) {
        var _dataWithReplacements_factMember = dataWithReplacements.factMember, id = _dataWithReplacements_factMember.id, customer_id = _dataWithReplacements_factMember.customer_id;
        var full_member_name = dataWithReplacements.full_member_name, full_member_address_name = dataWithReplacements.full_member_address_name, additional_info = dataWithReplacements.additional_info, member_branch_no = dataWithReplacements.member_branch_no, member_phone_number = dataWithReplacements.member_phone_number;
        setPdata(mappingMemberPes({
            id: id,
            customer_id: customer_id,
            full_member_name: full_member_name,
            full_member_address_name: full_member_address_name,
            additional_info: additional_info,
            member_branch_no: member_branch_no,
            member_phone_number: member_phone_number
        }));
    }
}
function mappingLoadByPesID(param) {
    var setFormdisabled = param.setFormdisabled, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setTagSelected = param.setTagSelected, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factTagPes && dataWithReplacements.factTagPes.length > 0) {
        var mappingData = dataWithReplacements.factTagPes.map(function(v) {
            return v.name;
        });
        setTagSelected(mappingData);
    } else {
        setTagSelected([]);
    }
    if (dataWithReplacements.dimMstPesStatus && dataWithReplacements.dimMstPesStatus.id > 1) {
        setFormdisabled(true);
    }
    dataWithReplacements.dim_mst_new_status_id = "";
    dataWithReplacements.dim_new_item_pes_sorts = [];
    if (dataWithReplacements.factItemPesColSort && dataWithReplacements.factItemPesColSort.length > 0) {
        var mappingCols = dataWithReplacements.factItemPesColSort.map(function(v) {
            return {
                id: v.dimMstItemPesCol.id,
                sortKey: v.dimMstItemPesCol.name
            };
        });
        while(mappingCols.length <= 3){
            mappingCols.push({
                id: "",
                sortKey: ""
            });
        }
        setColumnsort(_object_spread_props(_object_spread({}, columnsort), {
            columnsort: mappingCols
        }));
    }
}
function runMappingPipeline(_param) {
    var pipelineSteps = _param.pipelineSteps, context = _object_without_properties(_param, [
        "pipelineSteps"
    ]);
    pipelineSteps.forEach(function(fn) {
        fn(context);
    });
}
// public
export function mappingMemberPes(param) {
    var id = param.id, customer_id = param.customer_id, full_member_name = param.full_member_name, full_member_address_name = param.full_member_address_name, additional_info = param.additional_info, member_branch_no = param.member_branch_no, member_phone_number = param.member_phone_number;
    return {
        customerID: id,
        customerCode: customer_id,
        customerName: full_member_name,
        customerNameShort: "-",
        branchCode: member_branch_no,
        branchName: additional_info,
        address: full_member_address_name,
        phoneNumber: member_phone_number
    };
}
export function mappingOptionNewItemPesCol(options) {
    return options.filter(function(item) {
        return item.is_active;
    }).map(function(item) {
        var sortKey = "";
        switch(item.name_th){
            case "เลขที่เอกสาร":
                sortKey = "docNumber";
                break;
            case "เลขที่อ้างอิง":
                sortKey = "docRef";
                break;
            case "วันที่รับ":
                sortKey = "docReceiveDate";
                break;
            case "ผู้จัดจำหน่าย":
                sortKey = "docSupplierName";
                break;
            case "จำนวนสินค้า":
                sortKey = "docProductQty";
                break;
            case "มูลค่าก่อนภาษี":
                sortKey = "docExVatPrice";
                break;
            case "มูลค่าภาษี":
                sortKey = "docVatPrice";
                break;
            case "มูลค่าสุทธิ":
                sortKey = "docIncVatPrice";
                break;
            case "วันที่ตรวจสอบ":
                sortKey = "docReviewDate";
                break;
            case "หมายเหตุ":
                sortKey = "docRemark";
                break;
            default:
                break;
        }
        return {
            label: item.name_th,
            value: item.id,
            sortKey: sortKey
        };
    });
}
export function mappingPes(param) {
    var pesData = param.pesData, setDocSeletecteds = param.setDocSeletecteds, setProductRow = param.setProductRow, setPdata = param.setPdata, setFormdisabled = param.setFormdisabled, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setTagSelected = param.setTagSelected;
    var dataWithReplacements = Object.entries(pesData).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        acc[key] = value === null ? "" : value;
        return acc;
    }, {});
    runMappingPipeline({
        pipelineSteps: pipelineStepsFromPesID,
        setDocSeletecteds: setDocSeletecteds,
        setProductRow: setProductRow,
        setFormdisabled: setFormdisabled,
        columnsort: columnsort,
        setColumnsort: setColumnsort,
        setTagSelected: setTagSelected,
        setPdata: setPdata,
        dataWithReplacements: dataWithReplacements
    });
    return dataWithReplacements;
}
export var mapProductToRequestItem = function(products) {
    return products.filter(function(v) {
        return v.docID;
    }).map(function(v) {
        var isGR = v.__keySelected === "grReviewListState";
        var isEXP = v.__keySelected === "expListState";
        return {
            dim_new_gr_id: isGR ? v.docID : null,
            fact_expense_id: isEXP ? v.docID : null,
            total_price_product_no_vat: v.docNoVatPrice || 0,
            total_price_product_zero_vat: v.docZeroVatPrice || 0,
            total_price_product_seven_vat: v.docSevenVatPrice || 0,
            total_seven_vat_amount: v.docVatPrice || 0,
            total_price_before_vat: v.docExVatPrice || 0,
            grand_total_price: v.docIncVatPrice || 0,
            sum_item_quantity: v.docProductQty || 0,
            remark: v.docRemark || ""
        };
    });
};
export var jsonKeys = [
    "tag_peses",
    "fact_new_pes_items"
];
export var allowedFields = [
    "dim_mst_pes_status_id",
    "remark",
    "is_sort_manual",
    "fact_item_pes_col_sorts",
    "not_approve_reason"
].concat(_to_consumable_array(jsonKeys));
export function getActionPesDisplay(param) {
    var formdisabled = param.formdisabled, dimMstNewStatus = param.dimMstNewStatus, values = param.values;
    var ALLOWED_DRAFT_STATUS = [
        1
    ];
    var ALLOWED_APPROVED_STATUS = [
        1
    ];
    var ALLOWED_CANCEL_STATUS = [
        3,
        4
    ];
    var ALLOWED_PRINT_STATUS = [
        2
    ];
    var ALLOWED_RETRY_SYNC_STATUS = [
        4
    ];
    var id = dimMstNewStatus ? dimMstNewStatus.id : null;
    var canDraftStatus = !id || ALLOWED_DRAFT_STATUS.includes(id);
    var canApprovedStatus = ALLOWED_APPROVED_STATUS.includes(id);
    var canCancelStatus = ALLOWED_CANCEL_STATUS.includes(id);
    var canPrintStatus = ALLOWED_PRINT_STATUS.includes(id);
    var canRetrySyncStatus = ALLOWED_RETRY_SYNC_STATUS.includes(id);
    return {
        canDraftStatus: canDraftStatus,
        canApprovedStatus: canApprovedStatus,
        canCancelStatus: canCancelStatus,
        canPrintStatus: canPrintStatus,
        canRetrySyncStatus: canRetrySyncStatus
    };
}
export function isDisabledEditPes(param) {
    var dimMstNewStatus = param.dimMstNewStatus;
    var disabledList = [
        4,
        5
    ];
    if (dimMstNewStatus && disabledList.includes(parseInt(dimMstNewStatus.id))) {
        return true;
    }
    return false;
}
export function getDatePesByStatus(param) {
    var values = param.values, label = param.label;
    if (label === "สร้างใบส่งของ" && values.updated_approve_at) {
        return moment(values.updated_approve_at, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    } else if (label === "ยืนยันจัดส่ง" && values.ready_to_delivery_date) {
        return moment(values.ready_to_delivery_date, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    } else if (label === "เสร็จสิ้นDO" && values.fact_new_pes_id === 4 && values.updated_success_delivery_at) {
        return moment(values.updated_success_delivery_at, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    }
    return "-";
}
export var getDeliveredStatusList = [
    2
];
export var isPesOverDue = function(param) {
    var dueDeliveryDate = param.dueDeliveryDate, deliveredSuccess = param.deliveredSuccess, statusID = param.statusID;
    if (statusID !== 2) return false;
    var dueDate = moment(dueDeliveryDate).startOf("day");
    // Case 1: ถ้าส่งของแล้ว
    if (deliveredSuccess) {
        var deliveredDate = moment(deliveredSuccess).startOf("day");
        return deliveredDate.isAfter(dueDate); // ส่งช้าไหม
    }
    // Case 2: ยังไม่ส่ง → เช็คว่าวันนี้เลยวันกำหนดหรือยัง
    var today = moment().startOf("day");
    return today.isAfter(dueDate); // เลยกำหนดส่งไหม
};
export function getDocTableRowPesInit() {
    return {
        rowID: nanoid(),
        docID: "",
        docNumber: "",
        docRef: "",
        docReceiveDate: "",
        docSupplierName: "",
        docProductQty: "",
        docExVatPrice: "",
        docVatPrice: "",
        docIncVatPrice: "",
        docReviewDate: "",
        docRemark: "",
        is_checked: false,
        edit: false
    };
}
var baseRowMap = function(row) {
    return {
        rowID: nanoid(),
        docID: row.id || "",
        docNumber: row.doc_number || "",
        peakDocNumber: row.peak_sync_exp_code || "",
        docReceiveDate: row.doc_receive_date ? moment.utc(row.doc_receive_date).add(7, "hours").format("DD/MM/YYYY") : "",
        docSupplierName: row.dimSupplierInformation ? getSupplierFullName(row.dimSupplierInformation) + (row.dimSupplierInformation.company_branch_name ? " (".concat(row.dimSupplierInformation.company_branch_name, ")") : "") : "",
        docExVatPrice: row.total_price_before_vat || 0,
        docNoVatPrice: row.total_price_product_no_vat || 0,
        docZeroVatPrice: row.total_price_product_zero_vat || 0,
        docSevenVatPrice: row.total_price_product_seven_vat || 0,
        docVatPrice: row.total_price_vat || 0,
        docIncVatPrice: row.grand_total_price || 0,
        docReviewDate: row.financial_last_updated_at ? moment.utc(row.financial_last_updated_at).add(7, "hours").format("DD/MM/YYYY") : "",
        docRemark: row.remark || "",
        is_checked: false,
        edit: false
    };
};
var customRowMap = {
    grReviewListState: function(row) {
        return {
            docRef: row.refer || "",
            linkUrl: "/financial-accounting/creditor/goods-receipt/".concat(row.id),
            docProductQty: row.total_receive_quantity || 0
        };
    },
    expListState: function(row) {
        return {
            docRef: row.doc_refer || "",
            linkUrl: "/financial-accounting/expense/edit/".concat(row.id),
            docProductQty: row.totalQuantity || 0
        };
    }
};
export var mapRowToProductRow = function(row) {
    var _customRowMap_row___keySelected;
    return _object_spread_props(_object_spread({}, baseRowMap(row), ((_customRowMap_row___keySelected = customRowMap[row.__keySelected]) === null || _customRowMap_row___keySelected === void 0 ? void 0 : _customRowMap_row___keySelected.call(customRowMap, row)) || {}), {
        __keySelected: row.__keySelected || ""
    });
};
export function mergeSelectionsInOrder(selections, keys) {
    var seen = new Set();
    return keys.flatMap(function(key) {
        return selections[key] || [];
    }).filter(function(id) {
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
    });
}
export function removeCheckedProductsAndSyncSelections(param) {
    var productRow = param.productRow, setProductRow = param.setProductRow, setDocSeletecteds = param.setDocSeletecteds;
    // ลบแถวที่ถูกติ๊ก
    var remainingRows = productRow.filter(function(row) {
        return !row.is_checked;
    });
    // อัปเดตทั้ง 2 state
    setProductRow(remainingRows);
}
